export enum Direction {
  RTL = 'rtl',
  LTR = 'ltr',
}
